// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
export interface Instance {
  id: string;
  engine: string;
  version: string;
  status: 'available' | 'unavailable';
  activity: number;
  maint: string;
  class: string;
  iops: number;
  zone: string;
}

const instances: Instance[] = [
  {
    id: 'test-auto-db-1',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 42,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 35000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-2',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 34,
    maint: 'none',
    class: 'db.r3.large',
    iops: 38000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-3',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 5,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 22000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-4',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 39,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 32000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-5',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 13,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 19000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-6',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 45,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 27000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-7',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 11,
    maint: 'none',
    class: 'db.t2.large',
    iops: 7000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-8',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 19,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 32000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-9',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 10,
    maint: 'none',
    class: 'db.t2.small',
    iops: 37000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-10',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 25,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 6000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-11',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 29,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 3000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-12',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 27,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 33000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-13',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 45,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 13000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-14',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 19,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 13000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-15',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 19,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 6000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-16',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 45,
    maint: 'none',
    class: 'db.t2.small',
    iops: 16000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-17',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 4,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 27000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-18',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 42,
    maint: 'none',
    class: 'db.r3.large',
    iops: 5000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-19',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 14,
    maint: 'none',
    class: 'db.t2.small',
    iops: 33000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-20',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 44,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 27000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-21',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 42,
    maint: 'none',
    class: 'db.t2.large',
    iops: 26000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-22',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 13,
    maint: 'none',
    class: 'db.t2.large',
    iops: 17000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-23',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 3,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 38000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-24',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 0,
    maint: 'none',
    class: 'db.t2.large',
    iops: 19000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-25',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 10,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 24000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-26',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 32,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 32000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-27',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 40,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 10000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-28',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 1,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 26000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-29',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 11,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 35000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-30',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 16,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 1000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-31',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 19,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 3000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-32',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 36,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 26000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-33',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 24,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 33000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-34',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 29,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 20000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-35',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'unavailable',
    activity: 15,
    maint: 'none',
    class: 'db.t2.large',
    iops: 4000,
    zone: 'us-west-1b',
  },
  {
    id: 'test-auto-db-36',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 14,
    maint: 'none',
    class: 'db.t2.small',
    iops: 39000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-37',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'unavailable',
    activity: 33,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 19000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-38',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 35,
    maint: 'none',
    class: 'db.r3.large',
    iops: 12000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-39',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 7,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 23000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-40',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 38,
    maint: 'none',
    class: 'db.t2.large',
    iops: 9000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-41',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 44,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 14000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-42',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 17,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 15000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-43',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 31,
    maint: 'none',
    class: 'db.t2.large',
    iops: 5000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-44',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 1,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 21000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-45',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 4,
    maint: 'none',
    class: 'db.t2.large',
    iops: 11000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-46',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 46,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 7000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-47',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 24,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 25000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-48',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 47,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 39000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-49',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 26,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 25000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-50',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 31,
    maint: 'none',
    class: 'db.t2.large',
    iops: 9000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-51',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 6,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 5000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-52',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 4,
    maint: 'none',
    class: 'db.r3.large',
    iops: 37000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-53',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 1,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 27000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-54',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 48,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 37000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-55',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 37,
    maint: 'none',
    class: 'db.t2.large',
    iops: 35000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-56',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 34,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 22000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-57',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 42,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 34000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-58',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 29,
    maint: 'none',
    class: 'db.t2.large',
    iops: 12000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-59',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 15,
    maint: 'none',
    class: 'db.t2.small',
    iops: 16000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-60',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 23,
    maint: 'none',
    class: 'db.t2.large',
    iops: 4000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-61',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 18,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 3000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-62',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 20,
    maint: 'none',
    class: 'db.t2.small',
    iops: 18000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-63',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 37,
    maint: 'none',
    class: 'db.t2.small',
    iops: 37000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-64',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 9,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 0,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-65',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 4,
    maint: 'none',
    class: 'db.t2.small',
    iops: 26000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-66',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 39,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 11000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-67',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 31,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 0,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-68',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 49,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 26000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-69',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 17,
    maint: 'none',
    class: 'db.t2.large',
    iops: 16000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-70',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 34,
    maint: 'none',
    class: 'db.t2.large',
    iops: 8000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-71',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 46,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 11000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-72',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'unavailable',
    activity: 6,
    maint: 'none',
    class: 'db.t2.small',
    iops: 8000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-73',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 13,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 0,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-74',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 21,
    maint: 'none',
    class: 'db.t2.small',
    iops: 32000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-75',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 49,
    maint: 'none',
    class: 'db.t2.large',
    iops: 19000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-76',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 49,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 34000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-77',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 25,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 5000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-78',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 23,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 20000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-79',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 14,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 10000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-80',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 17,
    maint: 'none',
    class: 'db.t2.large',
    iops: 10000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-81',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 1,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 8000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-82',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 22,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 19000,
    zone: 'us-west-1b',
  },
  {
    id: 'test-auto-db-83',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 34,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 5000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-84',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 48,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 17000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-85',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 24,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 5000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-86',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 43,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 19000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-87',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 19,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 2000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-88',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 27,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 28000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-89',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 12,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 0,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-90',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 39,
    maint: 'none',
    class: 'db.r3.large',
    iops: 22000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-91',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 49,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 39000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-92',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 8,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 37000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-93',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 33,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 30000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-94',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 43,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 28000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-95',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 32,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 1000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-96',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 0,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 34000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-97',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 19,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 30000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-98',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'available',
    activity: 21,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 30000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-99',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'available',
    activity: 40,
    maint: 'none',
    class: 'db.r4.8xlarge',
    iops: 3000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-100',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 26,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 17000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-101',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 38,
    maint: 'none',
    class: 'db.r3.large',
    iops: 22000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-102',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 20,
    maint: 'none',
    class: 'db.t2.large',
    iops: 31000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-103',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 34,
    maint: 'none',
    class: 'db.t2.large',
    iops: 23000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-104',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 13,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 36000,
    zone: 'us-west-1a',
  },
  {
    id: 'test-auto-db-105',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 27,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 2000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-106',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 15,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 28000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-107',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 45,
    maint: 'none',
    class: 'db.r3.large',
    iops: 4000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-108',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 11,
    maint: 'none',
    class: 'db.t2.large',
    iops: 21000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-109',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 35,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 27000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-110',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 21,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 5000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-111',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 28,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 21000,
    zone: 'eu-west-2b',
  },
  {
    id: 'test-auto-db-112',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 38,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 14000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-113',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 25,
    maint: 'none',
    class: 'db.r3.large',
    iops: 38000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-114',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'unavailable',
    activity: 38,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 8000,
    zone: 'us-east-2a',
  },
  {
    id: 'test-auto-db-115',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 42,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 21000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-116',
    engine: 'MySQL',
    version: '5.6',
    status: 'unavailable',
    activity: 43,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 14000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-117',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 3,
    maint: 'none',
    class: 'db.t2.small',
    iops: 33000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-118',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 48,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 12000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-119',
    engine: 'Aurora',
    version: '5.6',
    status: 'available',
    activity: 1,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 27000,
    zone: 'eu-west-3a',
  },
  {
    id: 'test-auto-db-120',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'available',
    activity: 3,
    maint: 'none',
    class: 'db.t2.large',
    iops: 33000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-121',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 42,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 20000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-122',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 21,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 28000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-123',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 40,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 39000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-124',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 46,
    maint: 'none',
    class: 'db.t2.small',
    iops: 34000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-125',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 4,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 34000,
    zone: 'us-west-2a',
  },
  {
    id: 'test-auto-db-126',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 40,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 3000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-127',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 7,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 34000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-128',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 12,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 5000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-129',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 49,
    maint: 'none',
    class: 'db.t2.large',
    iops: 6000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-130',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 15,
    maint: 'none',
    class: 'db.r3.4xlarge',
    iops: 29000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-131',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 22,
    maint: 'none',
    class: 'db.t2.large',
    iops: 19000,
    zone: 'us-west-1b',
  },
  {
    id: 'test-auto-db-132',
    engine: 'Aurora',
    version: '5.5.53',
    status: 'available',
    activity: 30,
    maint: 'none',
    class: 'db.r4.xlarge',
    iops: 22000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-133',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'available',
    activity: 2,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 39000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-134',
    engine: 'MySQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 24,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 17000,
    zone: 'us-west-2b',
  },
  {
    id: 'test-auto-db-135',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 1,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 5000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-136',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 34,
    maint: 'none',
    class: 'db.t2.large',
    iops: 27000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-137',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 15,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 37000,
    zone: 'eu-central-1a',
  },
  {
    id: 'test-auto-db-138',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 47,
    maint: 'none',
    class: 'db.r3.large',
    iops: 31000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-139',
    engine: 'Aurora',
    version: '5.6',
    status: 'unavailable',
    activity: 22,
    maint: 'none',
    class: 'db.r3.large',
    iops: 18000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-140',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 35,
    maint: 'none',
    class: 'db.t2.medium',
    iops: 22000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-141',
    engine: 'PostgreSQL',
    version: '5.6',
    status: 'unavailable',
    activity: 25,
    maint: 'none',
    class: 'db.r4.2xlarge',
    iops: 5000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-142',
    engine: 'MySQL',
    version: '5.6',
    status: 'available',
    activity: 40,
    maint: 'none',
    class: 'db.r3.8xlarge',
    iops: 18000,
    zone: 'eu-west-2a',
  },
  {
    id: 'test-auto-db-143',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 24,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 16000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-144',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 16,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 30000,
    zone: 'us-west-1b',
  },
  {
    id: 'test-auto-db-145',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 1,
    maint: 'none',
    class: 'db.r3.2xlarge',
    iops: 17000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-146',
    engine: 'Aurora',
    version: '1.0.0.1',
    status: 'available',
    activity: 46,
    maint: 'none',
    class: 'db.r4.4xlarge',
    iops: 24000,
    zone: 'eu-west-3b',
  },
  {
    id: 'test-auto-db-147',
    engine: 'PostgreSQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 42,
    maint: 'none',
    class: 'db.t2.large',
    iops: 5000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-148',
    engine: 'PostgreSQL',
    version: '5.5.53',
    status: 'unavailable',
    activity: 7,
    maint: 'none',
    class: 'db.r3.xlarge',
    iops: 16000,
    zone: 'us-east-1a',
  },
  {
    id: 'test-auto-db-149',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'unavailable',
    activity: 7,
    maint: 'none',
    class: 'db.r3.large',
    iops: 7000,
    zone: 'eu-west-1a',
  },
  {
    id: 'test-auto-db-150',
    engine: 'MySQL',
    version: '1.0.0.1',
    status: 'available',
    activity: 39,
    maint: 'none',
    class: 'db.r3.large',
    iops: 31000,
    zone: 'eu-west-3b',
  },
];

export default instances;
